import React, { useEffect, useState, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../services/AuthContext";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { User, LogOut, Settings } from "react-feather";
import { logo } from "../imagepath";
import { getCustomerInstitutionByIp, getCustomerInstitutionByToken } from "../../services/instutionscustomersService";
import { getServiceRoleName } from "../../services/userService";
import axiosInstance from "../../services/axiosInstance";
import { useNavigate } from "react-router-dom";
import { loadProfilePhoto } from "../../utils/photoCache";
import { userAndPublishersListByUserId } from "../../services/userpanelservice";

const slugify = (text) => {
  if (!text) return "";
  const trMap = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'Ç': 'c', 'Ğ': 'g', 'İ': 'i', 'I': 'i', 'Ö': 'o', 'Ş': 's', 'Ü': 'u' };
  return text.toString().toLowerCase()
    .split('')
    .map(c => trMap[c] || c)
    .join('')
    .replace(/\s+/g, '-')         // Boşlukları tire yap
    .trim();
};

const Header2 = () => {
  const navigate = useNavigate();
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const [dbMap, setDbMap] = useState({});
  const [hasPublishers, setHasPublishers] = useState(false);
  const [loadingPanelFlags, setLoadingPanelFlags] = useState(true);

  const [panelType, setPanelType] = useState(null);
  const [panelName, setPanelName] = useState(null);

  useEffect(() => {
    document.body?.classList?.remove("menu-opened");
    return () => {
      document.body.className = "";
    };
  }, []);

  const { auth, setAuth } = useContext(AppContext);
  const [avatarUrl, setAvatarUrl] = useState(null);

  const defaultAvatar = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23E5E7EB'/%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-4.42 0-8 3.58-8 8v2h16v-2c0-4.42-3.58-8-8-8z' fill='lightgray'/%3E%3C/svg%3E";

  const dataHasItems = (data) => {
    if (!data) return false;
    if (Array.isArray(data)) return data.length > 0;
    if (typeof data === "object") {
      if (Array.isArray(data.data) && data.data.length > 0) return true;
      if (Array.isArray(data.publishers) && data.publishers.length > 0) return true;
      for (const key of Object.keys(data)) {
        if (Array.isArray(data[key]) && data[key].length > 0) return true;
      }
    }
    return false;
  };

  useEffect(() => {
    let mounted = true;
    const token = auth?.token || auth?.accessToken || null;

    const loadFlagsAndRole = async () => {
      setLoadingPanelFlags(true);
      getRoleName(auth.rolename); // Rol tipini çek (panelType ve panelName ayarlanır)
      getInstitution();
      getDatabase();
      loadDbMap();

      if (!token) {
        if (mounted) setLoadingPanelFlags(false);
        return;
      }

      try {
        const publishersResp = await userAndPublishersListByUserId(token).catch(() => null);

        if (!mounted) return;

        setHasPublishers(dataHasItems(publishersResp));
      } catch (err) {
        setHasPublishers(false);
      } finally {
        if (mounted) setLoadingPanelFlags(false);
      }
    };

    loadFlagsAndRole();
    return () => { mounted = false; };
  }, [auth.rolename, auth.token]); // Bağımlılıklar sabit kalır

  // Profil foto: IndexedDB + memory cache üzerinden yükle
  useEffect(() => {
    if (!auth?.id || !auth?.profileimage) { setAvatarUrl(null); return; }
    let revoke;
    loadProfilePhoto({ id: auth.id, fileName: auth.profileimage, token: auth.token })
      .then(({ url, revoke: rv }) => { setAvatarUrl(url); revoke = rv; })
      .catch(() => setAvatarUrl(null));
    return () => { if (revoke) revoke(); };
  }, [auth?.id, auth?.profileimage]);

  const [database, setDatabase] = useState([]);
  const [institution, setInstitution] = useState(null);

  // İstenen veritabanı sıralama düzeni
  const databaseOrder = [
    "İdeal Sosyal Bilimler Veritabanı",
    "İdeal Tıp Kitapları",
    "Din Bilimleri",
    "Konferans & Armağanlar",
  ];

  // MENÜDEN ÇIKARILMASI İSTENEN VERİTABANLARI LİSTESİ
  const EXCLUDED_DATABASES = [
    "Akademik Dergiler",
    "Popüler Dergiler",
    "Akademik Kitap",
    "Popüler Kitap"
  ];
  // ----------------------------------------------------


  const mobileMenuRef = useRef(null);
  useOnClickOutside(mobileMenuRef, () => {
    if (document.body.classList.contains("menu-opened")) {
      hideMobileMenu();
    }
  });


  // GÜNCELLENEN FONKSİYON: Veritabanlarını yeni API'den çek, filtrele ve sırala
  const getDatabase = async () => {
    try {
      // 1. Veriyi axios ile çek
      const res = await axiosInstance.get(
        "databases/search/databaseList/1",
      );

      let rawDatabases = Array.isArray(res?.data?.data) ? res.data.data : [];

      // 2. İSTENMEYENLERİ FİLTRELE
      rawDatabases = rawDatabases.filter(db => !EXCLUDED_DATABASES.includes(db.name));

      // 3. Kalan veritabanlarını haritada kaçıncı sırada olduklarına göre işaretle
      const orderedDatabases = rawDatabases.map(db => ({
        ...db,
        sortIndex: databaseOrder.indexOf(db.name)
      }));

      // 4. Sırala:
      //   - Bulunanlar (sortIndex >= 0) kendi sırasına göre.
      //   - Bulunmayanlar (sortIndex < 0) alfabetik olarak en sona.
      orderedDatabases.sort((a, b) => {
        if (a.sortIndex >= 0 && b.sortIndex < 0) return -1; // 'a' listede, 'b' değilse 'a' önde
        if (a.sortIndex < 0 && b.sortIndex >= 0) return 1;  // 'a' listede değil, 'b' ise 'b' önde
        if (a.sortIndex >= 0 && b.sortIndex >= 0) return a.sortIndex - b.sortIndex; // İkisi de listedeyse, listedeki sıraya göre
        return a.name.localeCompare(b.name, 'tr'); // İkisi de listede değilse, isme göre alfabetik
      });

      setDatabase(orderedDatabases);

    } catch (error) {
      console.error('Error fetching database list:', error);
    }
  };
  // ...

  const getInstitution = async () => {
    try {
      const token = auth.token || sessionStorage.getItem("authToken");
      let data;

      if (token && token !== "") {
        data = await getCustomerInstitutionByToken(token);
        setInstitution(data?.data || null);
      } else {
        data = await getCustomerInstitutionByIp();
        setInstitution(data?.data?.[0] || null);
      }

      if (data?.data) {
        // eslint-disable-next-line
        // console.log('Kurum Adı:', data?.data?.[0]?.name || data?.data?.name);
      }

    } catch (error) {
      console.error('Error fetching institution data:', error);
    }
  };

  // SADECE DB HARİTASI OLUŞTURMA İŞİ KALDI
  const loadDbMap = async () => {
    try {
      const res = await axiosInstance.get(
        "databases/search/databaseList/1",
      );
      const list = Array.isArray(res?.data?.data) ? res.data.data : [];
      const map = Object.fromEntries(list.map(d => [Number(d.id), d.name]));
      setDbMap(map);
    } catch (e) {
      console.error("DB listesi alınamadı:", e);
      setDbMap({});
    }
  };

  // GÜNCELLENEN ROL ADI ÇEKME VE PANEL TYPE/NAME AYARLAMA FONKSİYONU
  const getRoleName = async (role) => {
    // Rol 'USER' veya '0' ise dinamik paneli gösterme
    if (!role || role === "0" || role === "USER") {
      setPanelType(null);
      setPanelName(null);
      return;
    }
    try {
      const data = await getServiceRoleName(role);
      // Panel tipini ve adını state'e kaydet
      setPanelType(data?.data?.paneltype || null);
      setPanelName(data?.data?.rolename || null); // YENİ: Türkçe rol adını kaydet
    } catch (error) {
      console.error("Error fetching role name:", error);
      setPanelType(null);
      setPanelName(null);
    }
  }

  // auth.rolename değiştiğinde tüm verileri tekrar çek
  useEffect(() => {
    getRoleName(auth.rolename);
    getInstitution();
    getDatabase();
    loadDbMap();
  }, [auth.rolename, auth.token]);


  // change header background on scroll
  const [navbar, setNavbar] = useState(false);

  // --- GÜNCELLENEN MOBİL MENÜ STATE'LERİ ---
  const [mobileDatabasesMenu, setMobileDatabasesMenu] = useState(false);
  const [mobileHelpMenu, setMobileHelpMenu] = useState(false);
  const [mobileAboutMenu, setMobileAboutMenu] = useState(false);
  const [mobileSubscriptionMenu, setMobileSubscriptionMenu] = useState(false);
  const [mobileApplicationMenu, setMobileApplicationMenu] = useState(false);
  // --- GÜNCELLENEN MOBİL MENÜ STATE'LERİ SONU ---

  const [showProfile, setShowProfile] = useState(false);

  const openMobileMenu = () => {
    document.body?.classList?.add("menu-opened");
  };

  const hideMobileMenu = () => {
    document.body?.classList?.remove("menu-opened");
    // Mobil menü kapanırken tüm alt menüleri de kapat
    setMobileDatabasesMenu(false);
    setMobileHelpMenu(false);
    setMobileAboutMenu(false);
    setMobileSubscriptionMenu(false);
    setMobileApplicationMenu(false);
  };

  // YENİLENMİŞ TOGGLE FONKSİYONU
  const toggleMobileMenu = (setState, currentState) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Önce mobil menünün açık olduğundan emin ol
    if (!document.body.classList.contains("menu-opened")) {
      document.body.classList.add("menu-opened");
    }

    // State'i toggle et
    setState(!currentState);
  };

  // YENİLENMİŞ HANDLER'LAR - current state'i parametre olarak alıyor
  const openMobileDatabasesMenu = (e) => toggleMobileMenu(setMobileDatabasesMenu, mobileDatabasesMenu)(e);
  const openMobileHelpMenu = (e) => toggleMobileMenu(setMobileHelpMenu, mobileHelpMenu)(e);
  const openMobileAboutMenu = (e) => toggleMobileMenu(setMobileAboutMenu, mobileAboutMenu)(e);
  const openMobileSubscriptionMenu = (e) => toggleMobileMenu(setMobileSubscriptionMenu, mobileSubscriptionMenu)(e);
  const openMobileApplicationMenu = (e) => toggleMobileMenu(setMobileApplicationMenu, mobileApplicationMenu)(e);

  const changeHeaderBackground = () => {
    if (window.scrollY >= 90) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  const profile = useRef();
  useOnClickOutside(profile, () => setShowProfile(false));
  const profileClick = (e) => {
    e.preventDefault();
    setShowProfile(!showProfile);
  };

  const handleLogout = async () => {
    try {

      await axiosInstance.get(`${baseUrl}/service/idealonline/v1/instutationactivetoken/TokenExpire`, {
        headers: {
          Authorization: `Bearer ${auth.token}`
        }
      });

      setAuth({
        token: "",
        id: "",
        title: "",
        name: "",
        surname: "",
        email: "",
        telephone: "",
        address: "",
        regdate: "",
        tc: "",
        regstatus: "",
        mobileuser: "",
        updatedate: "",
      });
      sessionStorage.removeItem('auth');
      document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

      navigate("/logout");
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/logout");
    }
  };


  window.addEventListener("scroll", changeHeaderBackground);

  const ProfileMenuLinks = () => {

    // Admin/Yönetici rolü için özel isimlendirme yapar
    const getDynamicPanelLabel = (name, type) => {
      if (!name) return "Yönetim Paneli"; // Varsayılan

      // Eğer panel tipi "admin" ise veya Türkçe adı "Yönetici" içeriyorsa
      if (type === "admin" || name.toLowerCase().includes("yönetici")) {
        return "Yönetim Paneli";
      }

      // Diğer roller için (Yayıncı, Kütüphaneci vb.) rol adını kullan
      return `${name} Paneli`;
    };

    const dynamicPanelLabel = getDynamicPanelLabel(panelName, panelType);

    return (
      <>
        {/* 1. Profilim Linki (Herkes için) */}
        <li
          className="dropdown-item clickable-menu-item"
          onClick={() => { navigate('/profile'); setShowProfile(false); }}
          style={{ cursor: 'pointer' }}
        >
          <User size={14} color={"#1F2937"} className="feather-home me-1 ms-1" /> Profil
        </li>

        {/* 2. Kullanıcı Paneli Linki (Yayıncı değilse göster) */}
        {!(auth.rolename === "PUBLISHER" && hasPublishers) && (
          <li
            className="dropdown-item clickable-menu-item"
            onClick={() => {
              window.open(`${baseUrl}/panel/user`, "_blank", 'noopener,noreferrer');
              setShowProfile(false);
            }}
            style={{ cursor: 'pointer' }}
          >
            <Settings size={14} color={"#1F2937"} className="feather-home me-1 ms-1" /> Kullanıcı Paneli
          </li>
        )}


        {/* 3. Dinamik Yönetim Paneli Linki (Publisher için ekstra koşul) */}
        {!loadingPanelFlags && panelType && panelName && (
          // Ana Koşul: Rol USER veya 0 değilse
          (auth.rolename !== "USER" && auth.rolename !== "0") && (
            // Alt Koşul: Eğer rol PUBLISHER ise, hasPublishers da TRUE olmalı.
            auth.rolename !== "PUBLISHER" || (auth.rolename === "PUBLISHER" && hasPublishers)
          )
        ) && (
            <li
              className="dropdown-item clickable-menu-item"
              onClick={() => {
                window.open(`${baseUrl}/panel/${panelType}`, "_blank", 'noopener,noreferrer');
                setShowProfile(false);
              }}
              style={{ cursor: 'pointer' }}
            >
              <Settings size={14} color={"#1F2937"} className="feather-home me-1 ms-1" />
              {dynamicPanelLabel} {/* BURADA DİNAMİK İSİM KULLANILDI */}
            </li>
          )}


        <li
          className="dropdown-item clickable-menu-item text-danger"
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        >
          <LogOut size={14} color={"red"} className="headerIcon me-1 ms-1" /> Çıkış Yap
        </li>
      </>
    );
  };
  return (
    <header className="header">
      <div className="header-fixed">
        <nav
          className={
            navbar
              ? "navbar navbar-expand-lg header-nav scroll-sticky add-header-bg"
              : "navbar navbar-expand-lg header-nav scroll-sticky add-header-bg"
          }
        >
          <div className="container">
            <div className="navbar-header">
              <button className="border-0 bg-transparent" id="mobile_btn" type="button" onClick={openMobileMenu}>
                <span className="bar-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </button>

              <Link to="/home" className="navbar-brand logo mb-2">
                <img src={logo} alt="Logo" style={{ height: 22, width: "auto" }} />
              </Link>

            </div>
            <div className="main-menu-wrapper" ref={mobileMenuRef}>

              <div className="menu-header">
                <Link to="/home" className="navbar-brand logo">
                  <img src={logo} alt="Logo" style={{ height: 20, width: "auto" }} />
                </Link>

                <Link
                  id="menu_close"
                  className="menu-close"
                  to="#"
                  onClick={hideMobileMenu}
                >
                  <i className="fas fa-times"></i>
                </Link>
              </div>
              <ul className="main-nav">
                <li className="has-submenu active">
                  <Link to="/home" onClick={hideMobileMenu}>
                    Ana Sayfa
                  </Link>
                </li>
                {/* 1. VERİTABANLARI MENÜSÜ - DÜZELTİLDİ */}
                <li className={`has-submenu ${mobileDatabasesMenu ? 'active' : ''}`}>
                  <Link to="#" onClick={openMobileDatabasesMenu}>
                    Veri Tabanları
                    <i className="fas fa-chevron-down"></i>
                  </Link>
                  <ul className={mobileDatabasesMenu ? "submenu submenuShow submenu-databases" : "submenu submenu-databases"}>
                    <li key="ideal-sureli-yayinlar">
                      <Link to="/journal-list/all" onClick={hideMobileMenu}>
                        İdealonline Süreli Yayınlar
                      </Link>
                    </li>
                    {database.map((db) => (
                      <li key={db.id}>
                        {/* db.name yerine slugify(db.name) kullanıyoruz */}
                        <Link to={`/database/${slugify(db.name)}`} onClick={hideMobileMenu}>
                          {db.name?.replace(/Veritabanı/g, "Veri Tabanı")?.replace(/Veritabanları/g, "Veri Tabanları")}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>

                {/* 2. HAKKINDA MENÜSÜ */}
                <li className="has-submenu">
                  <Link to="/about-us" onClick={hideMobileMenu}>
                    Hakkımızda
                  </Link>
                </li>

                {/* 3. İletişim */}
                <li className={`has-submenu ${mobileSubscriptionMenu ? 'active' : ''}`}>
                  <Link to="/contact" onClick={hideMobileMenu}>
                    İletişim
                    {/* <i className="fas fa-chevron-down"></i> */}
                  </Link>
                </li>

                {/* 4. YARDIM MENÜSÜ */}
                <li className="has-submenu">
                  <Link to="/help" onClick={hideMobileMenu}>
                    Yardım
                  </Link>
                </li>

                {/* 5. BAŞVURU MENÜSÜ - DÜZELTİLDİ */}
                <li className={`has-submenu ${mobileApplicationMenu ? 'active' : ''}`}>
                  <Link to="#" onClick={openMobileApplicationMenu}>
                    Başvuru
                    <i className="fas fa-chevron-down"></i>
                  </Link>
                  <ul className={mobileApplicationMenu ? "submenu submenuShow" : "submenu"}>
                    <li>
                      <Link to="/publisher-apply" onClick={hideMobileMenu}>
                        Yayıncı Başvuru
                      </Link>
                    </li>
                    {/* Diğer başvuru alt menüleri buraya eklenebilir */}
                  </ul>
                </li>
                {/* --- YENİ BAŞVURU MENÜSÜ SONU --- */}
                {!auth.token ? (
                  <>
                    <li className="has-submenu d-lg-none">
                      <Link to="/login" onClick={hideMobileMenu}>
                        Giriş Yap
                      </Link>
                    </li>
                    <li className="has-submenu d-lg-none">
                      <Link to="/register" onClick={hideMobileMenu}>
                        Kayıt Ol
                      </Link>
                    </li>
                  </>
                ) : null}
              </ul>
            </div>
            <ul className="nav header-navbar-rht flex-row flex-nowrap gap-2 align-items-center justify-content-center">
              {/* Kurum adı rozeti */}
              {institution?.name && (
                <li className="nav-item d-none d-md-flex align-items-center">
                  <span
                    className="px-3 py-2 rounded-pill bg-default-color-1 border text-palette-blue small d-inline-flex align-items-center"
                    title={institution.name}
                  >
                    <i className="fa-solid fa-building-columns me-1" />
                    <span className="d-inline-block text-truncate" style={{ maxWidth: "150px" }}>
                      {institution.name}
                    </span>
                  </span>
                </li>
              )}

              {auth.token ? (
                <li className="nav-item user-nav">
                  <Link
                    to="#"
                    className={
                      showProfile ? "dropdown-toggle show" : "dropdown-toggle"
                    }
                    data-bs-toggle="dropdown"
                    onClick={profileClick}
                  >
                    <span className="user-img">
                      <img src={avatarUrl || defaultAvatar} alt="Profil" />
                      <span className="status online"></span>
                    </span>
                  </Link>
                  <div
                    ref={profile}
                    className={
                      showProfile
                        ? "users dropdown-menu dropdown-menu-right show modalPosition"
                        : "users dropdown-menu dropdown-menu-right"
                    }
                    data-popper-placement="bottom-end"
                  >
                    <div className="user-header">
                      <div className="avatar avatar-sm">
                        <img
                          src={avatarUrl || defaultAvatar}
                          alt="User"
                          className="avatar-img rounded-circle"
                          onError={(e) => (e.currentTarget.src = defaultAvatar)}
                        />
                      </div>
                      <div className="user-text">
                        <h6>{auth.name}</h6>
                        <p className="text-muted text mb-0">{auth.email}</p>
                      </div>
                    </div>
                    {ProfileMenuLinks()}
                  </div>
                </li>
              ) : (
                <>
                  <li className="nav-item">
                    <Link
                      className="text-sm text-newdarkfume btn-outline-primary rounded-3 btn w-auto px-3 py-1"
                      to="/login"
                    >
                      <span className="d-none d-sm-inline">Giriş Yap</span>
                      <span className="d-inline d-sm-none">Giriş</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="text-sm text-newdarkfume btn-outline-primary rounded-3 btn w-auto px-3 py-1"
                      to="/register"
                    >
                      <span className="d-none d-sm-inline">Kayıt Ol</span>
                      <span className="d-inline d-sm-none">Kayıt</span>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header2;